export default "__VITE_ASSET__Dz3EAsiF__"